import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../providers/UserProvider";
import EeljInfo from "../eelj/EeljInfo";
import { submitEelj, getOrderCheck } from "../../app/api";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

export const Payment = () => {
  const { t } = useTranslation();
  const generateCaptcha = () => Math.random().toString(36).slice(-5);

  const { eeljuud, userBio, userOrders, fetchLoggedUserData } = useContext(UserContext);
  const nav = useNavigate();
  const { id } = useParams();
  const [agree, setAgree] = useState(false);
  const [agreeError, setAgreeError] = useState(false);
  const [serverError, setServerError] = useState<any | undefined>(undefined);
  const [orderResponse, setOrderResponse] = useState<any | undefined>(undefined);
  const [paymentStatus, setPaymentStatus] = useState<any | undefined>(undefined);
  const [orderId, setOrderId] = useState<any | undefined>(undefined);
  const [captcha, setCaptcha] = useState(generateCaptcha);
  const [captchaInput, setCaptchaInput] = useState<string>('');
  const [captchaError, setCaptchaError] = useState(false);
  const [requestLoading, setRequestLoading] = useState(false);
  const [itqpay, setItqpay] = useState<any | undefined>(undefined);

  useEffect(() => {
    fetchLoggedUserData();
  }, [fetchLoggedUserData]);
  // useEffect(() => {
  //   if(!userBio) {
  //     nav('/login');
  //   }
  // }, [userBio]);

  const checkPayment = async () => {
    const orderCheck = await getOrderCheck(orderId);
    if (orderCheck.data.paymentStatus === "Хүлээгдэж байгаа") {
      alert(t('payment.paymentPending'));
      return;
    }
    setPaymentStatus(orderCheck.data.paymentStatus);
  };

  const eelj = useMemo(() => {
    return [...eeljuud.activeEelj].find(e => e.id === id);
  }, [id, eeljuud]);

  useEffect(() => {
    const order = userOrders?.find((o) => o.eelj?.id === id);

    if (order) {
      setOrderId(order.id);
      setOrderResponse(order.qpayData);
      setPaymentStatus(order.paymentStatus);
      if (order.qpayDataIT) {
        setItqpay(order.qpayDataIT);
      }
    }
  }, [userOrders]);

  const handleSubmit = useCallback(async () => {
    if (!agree) {
      setAgreeError(true);
      return;
    }
    if (captcha !== captchaInput) {
      setCaptchaError(true);
      return;
    }

    setAgreeError(false);
    setCaptchaError(false);
    setServerError(undefined);
    setRequestLoading(true);
    try {
      const resp = await submitEelj(id);
      setOrderId(resp.data.id);
      setOrderResponse(resp.data.qpayData);
      setPaymentStatus(resp.data.paymentStatus);
      if (resp.data.qpayDataIT) {
        setItqpay(resp.data.qpayDataIT);
      }
    } catch (err: any) {
      if (err.response) {
        setServerError(err.response.data.error);
      } else {
        setServerError(t('payment.pleaseWait'));
      }
    }
    setRequestLoading(false);
    setCaptcha(generateCaptcha());
    setCaptchaInput('');
  }, [agree, captcha, captchaInput]);

  return (
    <>
      {/* Dark Hero Header */}
      <div className="relative overflow-hidden bg-[#0a1628] -mt-20">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-primary-600/20 blur-[120px]" />
          <div className="absolute top-1/2 -left-40 w-[400px] h-[400px] rounded-full bg-secondary-500/15 blur-[100px]" />
        </div>
        <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`, backgroundSize: '60px 60px' }} />
        <div className="relative pt-40 pb-16 sm:pt-48 sm:pb-20">
          <div className="mx-auto max-w-7xl px-6 lg:px-8 text-center">
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-sm text-secondary-300 backdrop-blur-sm">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-secondary-400 animate-pulse" />
              {t('payment.badge')}
            </div>
            <h1 className="text-4xl sm:text-5xl font-extrabold text-white tracking-tight">
              {t('payment.title')}
            </h1>
          </div>
        </div>
      </div>

      {eelj &&
        <div className="bg-neutral-50 py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 pb-16 flex flex-col justify-center">
          <EeljInfo {...eelj} />
          {!orderResponse ?
            <>
              <div className="flex items-center justify-center mt-8">
                <input
                  id="link-checkbox"
                  className="mt-1 w-4 h-4 text-primary-600 bg-white border-neutral-200 rounded focus:ring-primary-500 focus:ring-2"
                  type="checkbox"
                  defaultChecked={false}
                  onChange={(e) => { setAgree(e.target.checked) }}
                />
                <label
                  htmlFor="link-checkbox"
                  className="ml-2 text-sm font-medium text-neutral-600"
                >
                  {t('payment.agreeText')}
                </label>
              </div>
              {agreeError && !agree &&
                <p className="text-danger-500 text-sm font-medium mt-2 text-center">{t('payment.agreeError')}</p>
              }
              <div className="flex flex-col items-center mt-8">
                <div className="w-full min-[600px]:w-[500px] bg-neutral-100 py-5 rounded-2xl">
                  <p className="text-primary-700 text-[42px] text-center font-bold select-none">
                    {captcha}
                  </p>
                </div>
                <label className="w-full min-[600px]:w-[500px] mt-4">
                  <span className="text-sm font-medium text-neutral-700">{t('payment.captchaLabel')}</span>
                  <input
                    required={true}
                    className="input mt-2"
                    type="text"
                    value={captchaInput}
                    onChange={(e) => {
                      setCaptchaError(false);
                      setCaptchaInput(e.target.value);
                    }}
                  />
                </label>
                {captchaError && <p className="text-danger-500 text-sm font-medium mt-2">{t('payment.captchaError')}</p>}

                {requestLoading ?
                  <button
                    disabled
                    className="mt-4 px-8 py-3 rounded-2xl bg-neutral-200 text-neutral-500 font-bold cursor-not-allowed"
                  >
                    {t('payment.ordering')}
                  </button>
                  :
                  <button
                    onClick={(e) => { e.preventDefault(); handleSubmit() }}
                    className="mt-4 px-8 py-3 rounded-full font-bold text-white bg-gradient-to-r from-primary-600 to-secondary-500 shadow-lg shadow-primary-600/25 hover:shadow-xl hover:shadow-secondary-500/30 hover:-translate-y-0.5 active:translate-y-0 focus:outline-none focus:ring-4 focus:ring-secondary-300 transition-all duration-200"
                  >
                    {t('payment.buyQPay')}
                  </button>
                }
              </div>
            </>
            :
            <>
              {paymentStatus === "Төлсөн" ?
                <div className="card mx-auto max-w-3xl p-10 mt-8 flex flex-col justify-center">
                  <p className="text-lg font-semibold text-neutral-900 mb-2">{t('payment.paymentSuccess')}</p>
                  <Link to={'/profile'} target="_blank" className="underline text-primary-600 hover:text-primary-700 font-medium">{t('payment.goToProfile')}</Link>
                </div> :
                eelj?.tulburdaraaavah ? (
                  <div className="card mx-auto max-w-3xl p-10 mt-8 flex flex-col justify-center text-center">
                    <p className="text-lg font-semibold text-neutral-900">
                      {t('payment.registeredSuccess')}
                    </p>
                  </div>
                ) : (
                  <div className="card mx-auto max-w-3xl p-10 mt-8 flex flex-col justify-center text-center">
                    {itqpay ? <p className="text-neutral-700 mb-4">{t('payment.payQRDual')}</p>
                      : <p className="text-neutral-700 mb-4">{t('payment.payQR')}</p>}
                    <img src={`data:image/png;base64, ${orderResponse.qr_image}`}
                      className="block mx-auto max-w-full h-auto rounded-xl"
                    />
                    <a href={orderResponse.qPay_shortUrl} target="_blank" className="underline text-primary-600 hover:text-primary-700 font-medium mt-4 inline-block">{t('payment.payApp')}</a>
                    <br />

                    {
                      itqpay &&
                      <>
                        <p className="text-neutral-700 mt-6 mb-4">{t('payment.payITQR')}</p>
                        <img src={`data:image/png;base64, ${itqpay.qr_image}`}
                          className="block mx-auto max-w-full h-auto rounded-xl"
                        />
                        <a href={itqpay.qPay_shortUrl} target="_blank" className="underline text-primary-600 hover:text-primary-700 font-medium mt-4 inline-block">{t('payment.payApp')}</a>
                        <br />
                      </>
                    }

                    <div className="w-full flex justify-center mt-4">
                      <button
                        onClick={checkPayment}
                        className="btn-secondary px-8 py-3"
                      >
                        {t('payment.checkPayment')}
                      </button>
                    </div>

                  </div>
                )

              }
            </>
          }
          {serverError &&
            <div className="bg-danger-50 border border-danger-200 text-danger-700 px-6 py-4 rounded-2xl mt-6 text-center">
              <span className="font-semibold">Алдаа: {JSON.stringify(serverError)}</span>
            </div>
          }
        </div>
        </div>
      }
    </>
  );
}

export default Payment;
